/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowinputstart3Inputs */

const en_aiflowinputstart3 = /** @type {(inputs: Aiflowinputstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your event in one sentence or paste a link`)
};

const de_aiflowinputstart3 = /** @type {(inputs: Aiflowinputstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreib dein Event in einem Satz oder füg einen Link ein`)
};

/**
* | output |
* | --- |
* | "Describe your event in one sentence or paste a link" |
*
* @param {Aiflowinputstart3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowinputstart3 = /** @type {((inputs?: Aiflowinputstart3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowinputstart3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowinputstart3(inputs)
	return de_aiflowinputstart3(inputs)
});
export { aiflowinputstart3 as "aiFlowInputStart" }